<template>
    <div class="container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="2">
                        <v-text-field v-model="ay" label="Academic Year" readonly outlined filled dense></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field v-model="standard" label="Standard" readonly outlined filled dense></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field v-model="division" label="Division" readonly outlined filled dense></v-text-field>
                    </v-col>

                    <v-col cols="2">
                        <v-text-field v-model="dayno" label="Day Number" readonly outlined filled dense></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field v-model="selecteddate" label="Date" readonly outlined filled dense></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <p>
                            <v-avatar size="25" class="edit-avatar ml-5">
                                <v-icon class="mr-2 edit-v-icon" @click="changeDate(selecteddate)" label="Date" title="edit">edit</v-icon>
                            </v-avatar>
                            <b>Edit Date</b>
                        </p>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                        Student List
                        <v-spacer></v-spacer>

                        <v-spacer></v-spacer>
                        <v-btn small color="blue" @click="saveattendance()">Save Attendance</v-btn>
                        <v-spacer></v-spacer>

                       

                        <!-- search code shiv -->
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search by Student name or by Registration Number" single-line hide-details></v-text-field>
                        </v-col>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>

        <div>
            <v-simple-table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>
                            <label class="form-checkbox">
                                <input type="checkbox" v-model="selectAll" @click="select" />
                                <i class="form-icon"></i>
                            </label>
                        </th>
                        <th>Roll Number</th>
                        <th>Student Name</th>
                        <th>Registration Number</th>
                        <!-- <th>Present</th> -->
                        <th>Total Present</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- <tr v-for="item in studentinfo" :key="item.la"> -->
                    <tr v-for="item in filteredItems" :key="item.la">
                        <td>
                            <label class="form-checkbox">
                                <input type="checkbox" :value="item.la" v-model="item.present" />
                                <i class="form-icon"></i>
                            </label>
                        </td>
                        <td>{{ item.rollnumber }}</td>
                        <td>{{ item.studentname }}</td>
                        <td>{{ item.grnumber }}</td>
                        <td>{{ item.totalpresent }}</td>
                    </tr>
                </tbody>
            </v-simple-table>
        </div>

        <v-dialog v-model="dialog" max-width="800px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="6" md="6">
                                <p><b>Update Attenance Date</b></p>
                                <v-dialog ref="dialog" v-model="modal1" :return-value.sync="date_edit" persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="date_edit" rounded outlined dense prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date_edit" scrollable>
                                        <v-spacer></v-spacer><v-btn text color="primary" @click="modal1 = false">Cancel</v-btn>
                                        <v-btn text color="primary" @click="$refs.dialog.save(date_edit)">OK</v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-btn class="button" @click="updateAttendanceDate(item)" :loading="loader">Update</v-btn>
                            <v-btn class="button" @click="dialog = false">Close</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            dialog: false,
            modal1: false,
            menu2: false,
            date_edit: "",
            loader: false,
            selected: [],
            selectAll: false,
            headers: [
                { text: "Roll Number", value: "rollnumber" },
                { text: "Student Name", value: "studentname" },
                { text: "Registration Number", value: "grnumber" },
                { text: "Present", value: "present" },
                { text: "Total Present", value: "totalpresent" },
            ],
            singleSelect: false,
            selectedTasks: [],
            selecteddate: "",
            selecteddate_edit: "",
            divoff: "",
            // studentinfo: "",
            studentinfo: [],

            ay: "",
            standard: "",
            division: "",
            dayno: "",
            search: "",
            date: "",
            snackbar_msg: null,
            color: "",
            snackbar: false,
            editedIndex: {
                rollnumber: "",
                studentname: "",
                grnumber: "",
                totalpresent: "",
                la: "",
            },
        }),

        mounted() {
            this.getEditAttendanceDetails();
        },
        computed: {
            filteredItems() {
                return this.studentinfo.filter((item) => {
                    return item.studentname.toLowerCase().indexOf(this.search.toLowerCase()) > -1 || item.grnumber.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                });
            },
        },
        methods: {
            updateAttendanceDate(item) {
                this.loader = true;
                const formData = {
                    divoff: this.$store.getters.divoff_id,
                    date: this.$store.getters.edit_date,
                    date_edit: this.date_edit,
                };
                axios
                    .post("/Academics/updateAttendanceDate", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.showSnackbar("#4caf50", "Updated Successfully...");
                            this.dialog = false;
                            this.selecteddate = res.data.date_edit;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.loader = false;
                        this.dialog = false;
                        //this.getEditAttendanceDetails()
                    });
            },
            changeDate(item) {
                this.dialog = true;
                this.date_edit = this.selecteddate_edit;
            },
            select() {
                this.selected = [];
                for (let i in this.studentinfo) {
                    this.studentinfo[i].present = false;
                }
                if (!this.selectAll) {
                    for (let i in this.studentinfo) {
                        this.selected.push(this.studentinfo[i].la);
                        this.studentinfo[i].present = true;
                    }
                }
            },
            getEditAttendanceDetails() {
                if (this.$store.getters.divoff_id == null || this.$store.getters.edit_date == null) {
                    alert("divoff");
                    this.$router.push({ name: "edit-attendance" });
                }
                //this.divoff=this.$store.getters.divoff_id
                const data = {
                    divoff: this.$store.getters.divoff_id,
                    date: this.$store.getters.edit_date,
                    date_edit: this.$store.getters.edit_date_new,
                    status: localStorage.getItem('setstatus_id'),
                };
                axios
                    .post("/Academics/getEditAttendanceDetails", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.studentinfo = res.data.studentinfo;
                            this.ay = res.data.ay;
                            this.standard = res.data.standard;
                            this.division = res.data.division;
                            this.dayno = res.data.dayno;
                            this.selecteddate = res.data.selecteddate;
                            this.selecteddate_edit = res.data.selecteddate_edit;

                            //  this.studentinfo.forEach(function(item) {
                            //       alert("presentstudents"+item.present)
                            //   this.selectedTasks[index] = item.present;
                            //   //index++;
                            // });
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            saveattendance() {
                //alert("presentstudents"+this.selectedTasks[0].ldiv)

                const data = {
                    presentstudent: [],
                    date: this.selecteddate,
                    allstudents: [],
                    divoff: this.$store.getters.divoff_id,
                    dayno: this.dayno,
                    status: localStorage.getItem('setstatus_id'),
                };
                var index = 0;
                // this.selectedTasks.forEach(function(item){
                //           // your logic
                //           //alert("presentstudents"+item.studentname)
                //           data.presentstudent[index]=item.la
                //           index++
                //   });
                this.studentinfo.forEach(function (item) {
                    if (item.present == true) {
                        data.presentstudent[index] = item.la;
                        index++;
                    }
                });

                index = 0;
                this.studentinfo.forEach(function (item) {
                    // your logic
                    //alert("presentstudents"+item.studentname)
                    data.allstudents[index] = item.la;
                    index++;
                });

                axios
                    .post("/Academics/saveEditedAttendance", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.studentinfo = res.data.studentinfo;
                            //this.snackbar_msg=res.data.snackbar_msg
                            this.snackbar = true;
                            this.showSnackbar("#4caf50", "Attendance Updated Successfully....");
                            //this.load=true
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
        },
    };
</script>
<style scoped>
    body {
        padding: 50px;
    }
</style>
